import { render, staticRenderFns } from "./BaseErrorMessages.vue?vue&type=template&id=1cc46e32"
import script from "./BaseErrorMessages.vue?vue&type=script&lang=js"
export * from "./BaseErrorMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports